import { useSyncExternalStore } from "react";

import {
  getMaintenance,
  subscribeMaintenance,
  type MaintenanceState,
} from "@/lib/maintenance-config";

/**
 * Trạng thái bảo trì, có PHẢN ỨNG khi máy chủ trả lời.
 *
 * 🔴 Component phải dùng hook này chứ đừng gọi thẳng `getMaintenance()`: giá trị đổi
 * GIỮA CHỪNG (lúc nhịp hỏi thăm về, hoặc lúc một lượt gọi API nhận 503). Gọi hàm
 * trần trong render thì React không biết có gì đổi, nên người dùng ngồi lại trên màn
 * hình cũ với mọi thao tác đều lỗi — mà không lỗi nào nói cho họ biết vì sao.
 */
export function useMaintenance(): MaintenanceState {
  return useSyncExternalStore(subscribeMaintenance, getMaintenance, getMaintenance);
}
